import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhoWeAre from './components/WhoWeAre';
import WhyRegenMed from './components/WhyRegenMed';
import OurServices from './components/OurServices';
import Manufacturing from './components/Manufacturing';
import BecomePartner from './components/BecomePartner';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <WhoWeAre />
      <WhyRegenMed />
      <OurServices />
      <Manufacturing />
      <BecomePartner />
      <ContactSection />
      <Footer />
    </div>
  );
}
